import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WidgetCoreModule } from '../widget-core.module';
import { PortletComponent } from './portlet.component';

@NgModule({
  entryComponents: [PortletComponent],
  declarations: [PortletComponent],
  imports: [
    CommonModule,
    WidgetCoreModule,
  ],
  exports: [PortletComponent]
})
export class PortletModule { }
